'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-expandable',
    cnExpanded = "".concat(CLASSNAME, "--expanded"),
    cnOverlay = "".concat(CLASSNAME, "--overlay"),
    cnWrapperInner = "".concat(CLASSNAME, "__wrapper-inner");
/**
 * 
 */

var Expandable = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Expandable, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Expandable);

  function Expandable() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Expandable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      innerHeight: _this.props.expanded ? 0 : _this.props.minHeight,
      overflow: _this.props.expanded ? '' : 'hidden'
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "body", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "innerBody", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onTransitionEnd", function (e) {
      if (e.target === _this.body.current) {
        _this.setState({
          innerHeight: 0,
          overflow: null
        });
      }

      _this.body.current.removeEventListener('transitionend', _this.onTransitionEnd);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onFocus", function () {
      // @see https://stackoverflow.com/a/27027108/1301058
      if (!_this.body.current) {
        return;
      }

      _this.body.current.scrollTo ? _this.body.current.scrollTo(0, 0) : _this.body.current.scrollTop = 0;
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Expandable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;
      onMount(this.innerBody.current.offsetHeight);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.body.current.removeEventListener('transitionend', this.onTransitionEnd);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$props = this.props,
          expanded = _this$props.expanded,
          children = _this$props.children;
      var innerHeight = this.state.innerHeight;
      return expanded !== nextProps.expanded || children !== nextProps.children || innerHeight !== nextState.innerHeight;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var expanded = nextProps.expanded,
          minHeight = nextProps.minHeight,
          prevExpanded = this.props.expanded,
          innerHeight = this.innerBody.current.offsetHeight;

      if (!this.body.current || prevExpanded === expanded) {
        return;
      }

      if (!expanded) {
        this.setState({
          innerHeight: innerHeight
        }, function () {
          // TODO why does requestAnimatioframe not work?
          window.setTimeout(function () {
            _this2.setState({
              innerHeight: minHeight,
              overflow: 'hidden'
            });
          }, 16);
        });
      } else {
        this.body.current.addEventListener('transitionend', this.onTransitionEnd);
        this.setState({
          innerHeight: innerHeight,
          overflow: 'hidden'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          className = _this$props2.className,
          classNameContent = _this$props2.classNameContent,
          children = _this$props2.children,
          expanded = _this$props2.expanded,
          overlay = _this$props2.overlay,
          _this$state = this.state,
          innerHeight = _this$state.innerHeight,
          overflow = _this$state.overflow,
          classes = [CLASSNAME, className],
          style = {
        maxHeight: innerHeight ? "".concat(innerHeight, "px") : null,
        overflow: overflow
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(classes, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnExpanded, expanded), _rollupPluginBabelHelpers.defineProperty(_classNames, cnOverlay, overlay), _classNames)),
        style: style,
        ref: this.body,
        onFocus: this.onFocus
      }, /*#__PURE__*/React__default.createElement("div", {
        ref: this.innerBody,
        className: classNames(cnWrapperInner, classNameContent)
      }, children));
    }
  }]);

  return Expandable;
}(React__default.Component);
Expandable.propTypes = {
  /** */
  children: PropTypes.node,

  /** Additional class name for content*/
  classNameContent: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  expanded: PropTypes.bool,

  /** */
  minHeight: PropTypes.number,

  /** */
  onMount: PropTypes.func,

  /** */
  overlay: PropTypes.bool
};
Expandable.defaultProps = {
  onMount: function onMount() {
    return void 0;
  },
  minHeight: 0,
  overlay: true
};

module.exports = Expandable;
